var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tiny"}},[_c('Editor',{attrs:{"init":{
    height: 500,
    menubar: true,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste code help wordcount'
    ],
    branding: false,
    toolbar:
    'undo redo | formatselect | bold italic backcolor | \
    alignleft aligncenter alignright alignjustify | \
    bullist numlist outdent indent | removeformat | help'
  }},on:{"input":_vm.textChanged},model:{value:(_vm.value.html),callback:function ($$v) {_vm.$set(_vm.value, "html", $$v)},expression:"value.html"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }